import React from "react";
import { Box } from "../../../../../../../shared/Box/Box";
import { Table as SharedTable } from "../../../../../../../shared/Table/Table";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import { Skeleton } from "../../../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../../../shared/Empty/Empty";
import classes from "./styles.module.scss";
import { SortAdornment } from "../../../../../../../shared/SortAdornment/SortAdornment";
import { ORDER_BY } from "../../../../../../../api/shopifyReports/useShopifyProductSalesReportQuery";
import { PageOverlayLoader } from "../../../../../../../shared/PageOverlayLoader/PageOverlayLoader";

export function Table({ reports, order }) {
  var { tBi: t } = useAppTranslation.BusinessInsights();
  var isEmpty = reports.value.length === 0 && !reports.isLoading;

  var renderSortWrap = (children, field) => (
    <SortAdornment
      value={order.value.by === field ? order.value.direction : undefined}
      onToggle={() => order.update(field)}
    >
      {children}
    </SortAdornment>
  );

  return (
    <Box>
      {reports.isLoading && <PageOverlayLoader />}
      {reports.isLoading && !reports.value.length && (
        <Skeleton count={15} height={40.5} borderRadius="0px" />
      )}
      {isEmpty && <Empty position="center" />}
      {!isEmpty && (
        <div className={classes.tableWrapper}>
          <SharedTable
            bgColor="white"
            data={reports.value}
            cols={[
              {
                data: renderSortWrap(
                  t("shopifyProductSalesReport.table.name"),
                  ORDER_BY.name,
                ),
                accessor: "name",
                className: classes.col,
              },
              {
                data: renderSortWrap(
                  t("shopifyProductSalesReport.table.vendor"),
                  ORDER_BY.vendor,
                ),
                accessor: "vendor",
                className: classes.col,
              },
              {
                data: renderSortWrap(
                  t("shopifyProductSalesReport.table.type"),
                  ORDER_BY.type,
                ),
                accessor: "type",
                className: classes.col,
              },
              {
                data: renderSortWrap(
                  t("shopifyProductSalesReport.table.netQuantity"),
                  ORDER_BY.netQuantity,
                ),
                accessor: "net_quantity",
                className: classes.col,
              },
              {
                data: renderSortWrap(
                  t("shopifyProductSalesReport.table.grossSales"),
                  ORDER_BY.grossSales,
                ),
                accessor: "gross_sales",
                className: classes.col,
              },
              {
                data: renderSortWrap(
                  t("shopifyProductSalesReport.table.netSales"),
                  ORDER_BY.netSales,
                ),
                accessor: "net_sales",
                className: classes.col,
              },
              {
                data: renderSortWrap(
                  t("shopifyProductSalesReport.table.returns"),
                  ORDER_BY.returns,
                ),
                accessor: "returns",
                className: classes.col,
              },
              {
                data: renderSortWrap(
                  t("shopifyProductSalesReport.table.discounts"),
                  ORDER_BY.discounts,
                ),
                accessor: "discounts",
                className: classes.col,
              },
              {
                data: renderSortWrap(
                  t("shopifyProductSalesReport.table.tax"),
                  ORDER_BY.tax,
                ),
                accessor: "tax",
                className: classes.col,
              },
            ]}
          />
        </div>
      )}
    </Box>
  );
}
